import React from "react";
import { Controller } from "react-hook-form";
import { useRef } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const CustomSelect = ({
  name,
  control,
  label,
  required = false,
  options = [],
  rules = {},
  disabled = false,
  onChange,
  formControlSx = {},
  ...props
}) => {
  const selectRef = React.useRef(null);
  return <Controller
    name={name}
    control={control}
    rules={{...rules, ...(required && {
        required: `${label} is required`,
      })
    }}
    shouldUnregister={false}
    render={({ field, fieldState: { error: fieldError } }) => (
      <FormControl
        ref={selectRef}
        fullWidth
        size="small"
        error={!!fieldError}
        disabled={disabled}
        margin="dense"
        sx={{
          minWidth: { xs: 200, sm: 250 },
          maxWidth:"100%",

          "& .MuiSelect-select.Mui-disabled": {
            WebkitTextFillColor: "#000",
            opacity: 1,
          },

          "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
            borderColor: "#d0d0d0",
          },
          ...formControlSx,
        }}
      >
        <InputLabel>
          {label}
          {required && (<span style={{ color: "red" }}>*</span>)}
        </InputLabel>

        <Select
          {...field}
          // inputRef={field.ref}
          inputRef={(element) => {
            field.ref(element);
            selectRef.current = element;
          }}
          label={label}
          onChange={(e) => {
            field.onChange(e);
            if (onChange) {onChange(e)}
          }}
          MenuProps={{
            PaperProps: {
              style: {
                borderRadius: 8,
                boxShadow: "0px 4px 8px rgba(20,30,50,0.10)",
                maxHeight: 300,
                width: 200,
              },
            },
          }}
          {...props}
        >
          {options.length === 0 ? (
            <MenuItem disabled value="">
              No records found
            </MenuItem>
          ) : (
            options.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{
                  whiteSpace: "normal",
                  lineHeight: 1.2,
                  maxWidth: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {opt.color && (
                    <span
                      style={{
                        display: "inline-block",
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: opt.color,
                      }}
                    />
                  )}
                  {opt.label}
                </div>
              </MenuItem>
            ))
          )}
        </Select>

        <FormHelperText>{fieldError ? fieldError.message : ""}</FormHelperText>
      </FormControl>
    )}
  />
};


export default CustomSelect;